import axios from "axios";
import Swal from "sweetalert2";

let aPIRootUrl = "";
const env = process.env.NODE_ENV;

switch (env) {
  case "local":
    aPIRootUrl = process.env.REACT_APP_API_BASE_LOCAL_URL;
    break;
  case "development":
    aPIRootUrl = process.env.REACT_APP_API_BASE_DEV_URL;
    break;
  case "production":
    aPIRootUrl = process.env.REACT_APP_API_BASE_PROD_URL;
    break;
  default:
    aPIRootUrl = "";
}

const api = axios.create({
  baseURL: aPIRootUrl,
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
});

let isLoggingOut = false;

const getLoggedInUser = () => {
  try {
    return JSON.parse(localStorage.getItem("userLoginData"));
  } catch {
    return null;
  }
};

api.interceptors.request.use(function (config) {
  const token = getLoggedInUser()?.token;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isUnauthorized = error.response?.status === 401;
    const hasActiveSession = Boolean(getLoggedInUser());

    if (isUnauthorized && hasActiveSession && !isLoggingOut) {
      isLoggingOut = true;
      localStorage.removeItem("userLoginData");

      Swal.fire({
        icon: "warning",
        title: "You are currently unauthorised",
        text: "Your session is no longer valid.",
        confirmButtonText: "Go to login",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        window.location.assign("/");
      });
    }

    return Promise.reject(error);
  }
);

export default api;
